// extracted by mini-css-extract-plugin
export default {"alert_container":"ez3leNih9qA67U8HAn8G","alert_header":"dYurhvKqzA7R4pBALJsh","header_control":"Bepp4JvYDv0o7sc1IKNp","copy_button":"xnQcrMezNuZLHuq5JKyS"};